/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForScheduledTask extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForScheduledTask");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForScheduledTask.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForScheduledTask>): BackgroundJobPayloadForScheduledTask {
        let obj = Object.assign(new BackgroundJobPayloadForScheduledTask(), model);
        BackgroundJobPayloadForScheduledTask.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForScheduledTask>): BackgroundJobPayloadForScheduledTask {
        if (!model) return null;
        return BackgroundJobPayloadForScheduledTask.newInstance(<BackgroundJobPayloadForScheduledTask> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForScheduledTask) {
        if (!obj) return;

        models.BackgroundJobPayloadForScheduledTask.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForScheduledTask): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForScheduledTask.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    schedule_id: string;

}
